import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import BlogAuthor from './BlogAuthor';
import BlogCategories from '../BlogCategories';
import ForumNav from '../ForumNav';
export default class BlogItemSidebar extends Component {
  view() {
    return m("div", {
      className: 'FlarumBlog-Article-Sidebar'
    }, m("ul", null, listItems(this.items().toArray())));
  }
  items() {
    const itemlist = new ItemList();
    itemlist.add('author', BlogAuthor.component(this.attrs), 0);
    itemlist.add('categories', BlogCategories.component(this.attrs), 0);
    itemlist.add('nav', ForumNav.component(this.attrs), 0);
    return itemlist;
  }
}
flarum.reg.add('v17development-blog', 'forum/components/BlogItemSidebar/BlogItemSidebar', BlogItemSidebar);